import React from 'react';
import { VideoIcon } from 'lucide-react';
import { TornEdge } from './TornEdge';
import { Reveal } from './Reveal';
import { ActionLink } from './Buttons';
import { contact } from '../data/contact';
export function VideoCall() {
  return <section id="videollamada" aria-labelledby="videollamada-title" className="relative overflow-hidden bg-ink py-20 sm:py-28" data-id="element-228" data-mp="15me4lr83ptws">
      <TornEdge colorClassName="bg-ink" data-id="element-229" data-mp="1y9qnnrf1zjlc" />
      <div aria-hidden="true" className="smoke-veil pointer-events-none absolute inset-0 opacity-50" data-id="element-230" data-mp="1ya0jhvms4kyy" />
      <div aria-hidden="true" className="gold-dust pointer-events-none absolute inset-0 opacity-60" data-id="element-231" data-mp="22d6oz122i84d" />

      <div className="relative mx-auto flex w-full max-w-3xl flex-col items-center px-5 text-center sm:px-8" data-id="element-232" data-mp="1tiiix8oo4mei">
        <Reveal stamp data-id="element-233" data-mp="2h7t95w8e6yee">
          <span className="flex h-20 w-20 items-center justify-center rounded-full border border-dashed border-gold/70" data-id="element-234" data-mp="2h7kvw38cxr2o">
            <VideoIcon className="h-8 w-8 text-gold" aria-hidden="true" data-id="element-235" data-mp="2m0e2kwndz9he" />
          </span>
        </Reveal>

        <Reveal delay={0.08} className="mt-7" data-id="element-236" data-mp="3rtukuj9nplch">
          <span className="inline-flex items-center gap-2.5 border border-emerald-soft/60 bg-emerald/20 px-4 py-2 font-folio text-[0.62rem] uppercase tracking-[0.24em] text-paper" data-id="element-237" data-mp="3nv4xbxuwmnf4">
            <span aria-hidden="true" className="pulse-dot h-2 w-2 rounded-full bg-emerald-soft" data-id="element-238" data-mp="pw3b4q1z30b" />
            Atención en vivo
          </span>
        </Reveal>

        <Reveal delay={0.14} data-id="element-239" data-mp="afpe43idfe3i">
          <h2 id="videollamada-title" className="mt-7 font-display text-[1.7rem] font-light uppercase leading-tight tracking-[0.06em] text-gold sm:text-4xl" data-id="element-240" data-mp="aee2ximlj42d">
            Atención Espiritual por Videollamada
          </h2>
          <p className="mx-auto mt-6 max-w-xl text-[0.98rem] leading-relaxed text-body sm:text-lg" data-id="element-241" data-mp="2q6lfup7p9awk">
            Habla directamente con nuestro chamán desde la comodidad de tu
            hogar. Agenda tu consulta personalizada por videollamada.
          </p>
        </Reveal>

        <Reveal delay={0.2} className="mt-10 w-full sm:w-auto" data-id="element-242" data-mp="p6giqzrnjtvy">
          <ActionLink href={contact.videoCallHref} variant="emerald" target="_blank" rel="noreferrer" className="w-full sm:w-auto" data-id="element-243" data-mp="u4i3dp4q819j">
            <VideoIcon className="h-4 w-4" aria-hidden="true" data-id="element-244" data-mp="134wooohoxgd1" />
            Agendar Videollamada
          </ActionLink>
        </Reveal>
      </div>
    </section>;
}